// extracted by mini-css-extract-plugin
export default {"skeleton":"loader__skeleton__KrGNO","hide":"loader__hide__fAyk_"};